module.exports = __webpack_public_path__ + "static/media/layout.6194fb20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mediaDnd/layout.svg
// module id = 1413
// module chunks = 1